package cz.lhoracek.mapl.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import cz.lhoracek.mapl.ui.getInitials
import cz.lhoracek.mapl.ui.hexToColor

@Composable
fun PlayerAvatar(
    name: String,
    colorHex: String,
    modifier: Modifier = Modifier,
    size: Dp,
    textStyle: TextStyle = MaterialTheme.typography.titleMedium
) {
    val color = hexToColor(colorHex)
    Box(
        modifier = modifier
            .size(size)
            .background(color, CircleShape),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = getInitials(name),
            style = textStyle,
            color = Color.White,
            fontWeight = FontWeight.Bold,
            maxLines = 1
        )
    }
}
